import React, { useState } from 'react';
import { Mail, Send, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Newsletter = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast({
        title: '❌ Ungültige E-Mail',
        description: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        variant: 'destructive'
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/newsletter`, { email });
      
      if (response.data.success) {
        setIsSuccess(true);
        toast({
          title: '✅ Erfolgreich angemeldet!',
          description: response.data.message,
        });
        
        setEmail('');
        setTimeout(() => setIsSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      toast({
        title: '❌ Fehler',
        description: error.response?.data?.detail || 'Newsletter-Anmeldung fehlgeschlagen. Bitte versuchen Sie es später erneut.',
        variant: 'destructive'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-orange-500 to-yellow-500">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-6">
            <Mail className="text-white" size={32} />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Bleiben Sie informiert
          </h2>
          <p className="text-lg text-white/90 mb-8">
            Melden Sie sich für unseren Newsletter an und erhalten Sie regelmäßig
            Informationen zu neuen Projekten, Technologien und Angeboten.
          </p>

          {isSuccess ? (
            <div className="flex flex-col items-center justify-center py-8">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4">
                <CheckCircle className="text-green-600" size={32} />
              </div>
              <p className="text-xl font-semibold text-white">
                Vielen Dank für Ihre Anmeldung!
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="max-w-xl mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Ihre E-Mail-Adresse"
                  className="flex-1 h-14 px-6 text-lg bg-white border-none focus:ring-2 focus:ring-white"
                  disabled={isSubmitting}
                  required
                />
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="h-14 px-8 bg-slate-900 hover:bg-slate-800 text-white font-semibold text-lg"
                >
                  {isSubmitting ? (
                    <span className="flex items-center">
                      <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                      Anmelden...
                    </span>
                  ) : (
                    <span className="flex items-center">
                      Anmelden
                      <Send size={20} className="ml-2" />
                    </span>
                  )}
                </Button>
              </div>
              <p className="text-sm text-white/80 mt-4">
                Wir respektieren Ihre Privatsphäre. Sie können sich jederzeit wieder abmelden.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
